var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cf-container" },
    [
      _vm.hasOverrideDayWindows
        ? _c(
            "md-table",
            [
              _c(
                "md-table-row",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("md-table-head", { staticClass: "time-range-columns" }, [
                    _vm._v("From"),
                  ]),
                  _c("md-table-head", { staticClass: "time-range-columns" }, [
                    _vm._v("To"),
                  ]),
                  _c("md-table-head", { staticClass: "max-stops-column" }, [
                    _vm._v("Max stops"),
                  ]),
                  _vm.hasCapacitySettings("volume")
                    ? _c(
                        "md-table-head",
                        { staticClass: "capacity-settings-columns" },
                        [_vm._v("\n                Max volume\n            ")]
                      )
                    : _vm._e(),
                  _vm.hasCapacitySettings("weight")
                    ? _c(
                        "md-table-head",
                        { staticClass: "capacity-settings-columns" },
                        [_vm._v("\n                Max weight\n            ")]
                      )
                    : _vm._e(),
                  _vm.hasCapacitySettings("quantity")
                    ? _c(
                        "md-table-head",
                        { staticClass: "capacity-settings-columns" },
                        [_vm._v("\n                Max quantity\n            ")]
                      )
                    : _vm._e(),
                  _c("md-table-head", { staticClass: "cut-off-label-column" }, [
                    _vm._v("Cut off"),
                  ]),
                  _c("md-table-head", [_vm._v("Actions")]),
                ],
                1
              ),
              _vm._l(
                _vm.filteredOverrideDayWindows,
                function (overrideDayWindow) {
                  return _c(
                    "md-table-row",
                    { key: overrideDayWindow.overrideDayWindowId },
                    [
                      _c(
                        "md-table-cell",
                        { staticClass: "time-range-columns" },
                        [
                          _c(
                            "form-group",
                            [
                              _c("md-icon", [_vm._v("access_time")]),
                              _c("time-picker", {
                                attrs: {
                                  time: overrideDayWindow.startTime,
                                  "all-time-options": false,
                                  "is-required": true,
                                },
                                on: {
                                  selectedTime: function (
                                    selectedTime,
                                    isTimeValid
                                  ) {
                                    _vm.handleSetStartTime(
                                      selectedTime,
                                      isTimeValid,
                                      overrideDayWindow
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "md-table-cell",
                        { staticClass: "time-range-columns" },
                        [
                          _c(
                            "form-group",
                            [
                              _c("md-icon", [_vm._v("access_time")]),
                              _c("time-picker", {
                                attrs: {
                                  time: overrideDayWindow.endTime,
                                  "all-time-options": false,
                                  "is-required": true,
                                },
                                on: {
                                  selectedTime: function (
                                    selectedTime,
                                    isTimeValid
                                  ) {
                                    _vm.handleSetEndTime(
                                      selectedTime,
                                      isTimeValid,
                                      overrideDayWindow
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "md-table-cell",
                        { staticClass: "max-stops-column" },
                        [
                          _c(
                            "form-group",
                            [
                              _c("md-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: overrideDayWindow.maxStops,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      overrideDayWindow,
                                      "maxStops",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "overrideDayWindow.maxStops",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.hasCapacitySettings("volume")
                        ? _c(
                            "md-table-cell",
                            { staticClass: "capacity-settings-columns" },
                            [
                              _c(
                                "form-group",
                                [
                                  _c("md-input", {
                                    attrs: { type: "number" },
                                    model: {
                                      value: overrideDayWindow.maxVolume,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          overrideDayWindow,
                                          "maxVolume",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "overrideDayWindow.maxVolume",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.hasCapacitySettings("weight")
                        ? _c(
                            "md-table-cell",
                            { staticClass: "capacity-settings-columns" },
                            [
                              _c(
                                "form-group",
                                [
                                  _c("md-input", {
                                    attrs: { type: "number" },
                                    model: {
                                      value: overrideDayWindow.maxWeight,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          overrideDayWindow,
                                          "maxWeight",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "overrideDayWindow.maxWeight",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.hasCapacitySettings("quantity")
                        ? _c(
                            "md-table-cell",
                            { staticClass: "capacity-settings-columns" },
                            [
                              _c(
                                "form-group",
                                [
                                  _c("md-input", {
                                    attrs: { type: "number" },
                                    model: {
                                      value: overrideDayWindow.maxQuantity,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          overrideDayWindow,
                                          "maxQuantity",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "overrideDayWindow.maxQuantity",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "md-table-cell",
                        {
                          class:
                            "cut-off-label-column " +
                            (_vm.$_isValidServiceAreaCutOffCombination(
                              overrideDayWindow,
                              _vm.dayOfTheWeek
                            )
                              ? ""
                              : "invalid-cutt-off-options"),
                        },
                        [
                          _c("md-icon", [_vm._v("access_time")]),
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$_generateServiceAreaCutOffLabel(
                                  overrideDayWindow,
                                  _vm.dayOfTheWeek
                                )
                              ) +
                              "\n                "
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "edit-cutoff-button",
                              on: {
                                click: function () {
                                  return _vm.handleEditCuttOff(
                                    overrideDayWindow,
                                    _vm.dayOfTheWeek
                                  )
                                },
                              },
                            },
                            [_c("md-icon", [_vm._v("arrow_drop_down")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "md-table-cell",
                        [
                          _c(
                            "md-button",
                            {
                              staticClass: "md-danger md-just-icon md-round",
                              attrs: { title: "Delete override day window" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteOverrideDayWindow(
                                    overrideDayWindow
                                  )
                                },
                              },
                            },
                            [_c("md-icon", [_vm._v("delete")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }
              ),
            ],
            2
          )
        : _vm._e(),
      !_vm.hasOverrideDayWindows
        ? _c("div", { staticClass: "text-center" }, [
            _c("p", { staticClass: "no-result-message" }, [
              _vm._v("List is empty."),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "add-override-day-window-container" },
        [
          _c(
            "md-button",
            {
              staticClass:
                "md-button md-primary add-override-day-window-button",
              on: { click: _vm.handleAddOverrideDayWindow },
            },
            [
              _c("md-icon", [_vm._v("add")]),
              _vm._v("\n            Add Delivery Window\n        "),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }